import { render, staticRenderFns } from "./BalaEdit.vue?vue&type=template&id=5cc67ff4&scoped=true"
import script from "./BalaEdit.vue?vue&type=script&lang=js"
export * from "./BalaEdit.vue?vue&type=script&lang=js"
import style0 from "./BalaEdit.vue?vue&type=style&index=0&id=5cc67ff4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc67ff4",
  null
  
)

export default component.exports